import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { interval } from 'rxjs/observable/interval';

@Component({
  selector: 'bra-countdown',
  templateUrl: './bra-countdown.component.html',
  styleUrls: ['./bra-countdown.component.css']
})
export class BraCountdownComponent implements OnInit {

  constructor() { }

  private subscription: Subscription;

  @Input()
  secondsToCount = 5;

  @Output() countdownFinished = new EventEmitter<boolean>();

  ngOnInit() {
    this.subscription = interval(1000)
      .subscribe(() => { this.startCountdown(); });
  }

  private startCountdown() {
    this.secondsToCount == 0 ? this.stopCountdown() : --this.secondsToCount;
  }

  private stopCountdown() {
    this.subscription.unsubscribe();
    this.countdownFinished.emit(true);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-countdown/bra-countdown.component.ts